import { FC } from 'react';
import { type Quiz } from '@teachur/http-client';
import { useSingleCourse } from '@new/features/courses/contexts/SingleCourseProvider';
import { Progress } from '@new/common/ui/Progress/Progress';
import { LockedChip } from '@new/common/ui/Chip/LockedChip';
import { useExamProgress } from '@new/features/courses/hooks/useExamProgress';

const PERCENTAGE_MULTIPLIER = 100;

interface OverallProgressProps {
  attempts: Quiz[];
}

export const OverallProgress: FC<OverallProgressProps> = ({ attempts }) => {
  const { course } = useSingleCourse();

  const isLocked =
    course?.selfAssessmentCompletionPercentage !== undefined &&
    course.selfAssessmentCompletionPercentage < 100;

  const { totalQuestions, correctAnswers, isCompleted } = useExamProgress(attempts);

  const overallProgress =
    totalQuestions > 0 ? (correctAnswers / totalQuestions) * PERCENTAGE_MULTIPLIER : 0;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <span className="flex gap-1 items-center [font-size:var(--fs-p4)]! text-(--neutral-black-NB500)!">
          Overall progress {isLocked && <LockedChip />}
        </span>

        <span className="[font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! font-medium text-(--neutral-black-NB600)!">
          {correctAnswers} out of {totalQuestions} questions answered correctly
        </span>
      </div>

      <Progress value={overallProgress} color={isCompleted ? 'var(--success-S600)' : undefined} />
    </div>
  );
};
